import { SponsorsStore } from '@services/Sponsors/declarations'

export const sponsorsList : SponsorsStore['getClubSponsors'] = {
  '@context': '/api/contexts/Thread',
  '@id': '/api/clubs/3abf15a877a6dabfc67806017ab195526a3b011d/communications/threads',
  '@type': 'hydra:Collection',
  'hydra:totalItems': 7,
  'hydra:member': [
    {
      '@context': '/api/contexts/Thread',
      '@id': '/api/clubs/3abf15a877a6dabfc67806017ab195526a3b011d/communications/threads',
      '@type': 'hydra:Collection',
      hash: '1',
      name: 'Sponsor 1',
      url: '',
      image: 'https://www.alleycat.org/wp-content/uploads/2019/03/FELV-cat.jpg',
      order: 1,
    },
    {
      '@context': '/api/contexts/Thread',
      '@id': '/api/clubs/3abf15a877a6dabfc67806017ab195526a3b011d/communications/threads',
      '@type': 'hydra:Collection',
      hash: '2',
      name: 'Sponsor 2',
      url: '',
      image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Cat03.jpg/1200px-Cat03.jpg',
      order: 3,
    },
    {
      '@context': '/api/contexts/Thread',
      '@id': '/api/clubs/3abf15a877a6dabfc67806017ab195526a3b011d/communications/threads',
      '@type': 'hydra:Collection',
      hash: '3',
      name: 'Sponsor 3',
      url: '',
      image: 'https://images.pexels.com/photos/45201/kitty-cat-kitten-pet-45201.jpeg',
      order: 2,
    },
    {
      '@context': '/api/contexts/Thread',
      '@id': '/api/clubs/3abf15a877a6dabfc67806017ab195526a3b011d/communications/threads',
      '@type': 'hydra:Collection',
      hash: '4',
      name: 'Sponsor 4',
      url: '',
      image: 'https://d2zp5xs5cp8zlg.cloudfront.net/image-79322-800.jpg',
      order: 6,
    },
    {
      '@context': '/api/contexts/Thread',
      '@id': '/api/clubs/3abf15a877a6dabfc67806017ab195526a3b011d/communications/threads',
      '@type': 'hydra:Collection',
      hash: '5',
      name: 'Sponsor 5',
      url: '',
      image: 'https://www.communitycatspodcast.com/wp-content/uploads/2023/03/Cat6.jpg',
      order: 1111,
    },
    {
      '@context': '/api/contexts/Thread',
      '@id': '/api/clubs/3abf15a877a6dabfc67806017ab195526a3b011d/communications/threads',
      '@type': 'hydra:Collection',
      hash: '6',
      name: 'Sponsor 6',
      url: '',
      image: 'https://media-be.chewy.com/wp-content/uploads/2024/10/17130011/cat-crying.jpg',
      order: 10,
    },
  ],
}
